import { useState } from "react";
import { motion } from "motion/react";
import mapIcon from "@icons/map.svg";
import Image from "next/image";
import useWindowSize from "@utils/use_window_size";
import RouteMap from "@components/RouteMap";
import deleteCircleIcon from "@icons/delete-circle.svg";

function MapPopup({
  className = "",
  label,
  startPoint,
  endPoint,
  visible,
}: {
  className?: string;
  label: string;
  startPoint: be.LatLng;
  endPoint: be.LatLng;
  visible: boolean;
}): JSX.Element {
  const [showMap, setShowMap] = useState(false);
  useWindowSize(); // Rerenders the component on window size change.

  const variants = {
    visible: {
      opacity: 1,
      y: 8,
      display: "block",
    },
    hidden: {
      opacity: 0.5,
      y: -3,
      transitionEnd: {
        display: "none",
      },
    },
  };

  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate={visible ? "visible" : "hidden"}
      className="relative text-right -mt-1 overflow-visible"
    >
      {!showMap && (
        <div
          onClick={() => setShowMap(true)}
          className={`overflow-visible transition-opacity cursor-pointer mr-1 mb-0 ${className}`}
        >
          <div className="underline relative text-gray-500 ">
            <span className="pr-1 hidden sm:inline ">{label}</span>
            <Image
              src={mapIcon}
              className="m-1 top-2 overflow-visible hidden xs:inline"
              height={20}
              width={20}
              alt="map"
            />
          </div>
        </div>
      )}

      {showMap && (
        <div className="relative mt-1 mb-3">
          <RouteMap startPoint={startPoint} endPoint={endPoint} width="100%" height="15rem" />
          <div className="bg-white absolute top-0 right-0  pl-1.5 pb-0.5 pt-2 pr-1  rounded-bl-lg opacity-75">
            <Image
              src={deleteCircleIcon}
              className="cursor-pointer z-10"
              onClick={() => setShowMap(false)}
              height={15}
              width={15}
              alt="close map"
            />
          </div>
        </div>
      )}
    </motion.div>
  );
}

export default MapPopup;
